<template>
  <v-master>
    <div class="py-14 sm:pt-20 sm:pb-36 relative">
      <div class="container max-w-sm">
        <a
          class="block mb-10"
          href="https://carbonii.com/"
        >
          <img
            src="/img/icons/svg/logo-login.svg"
            alt="Carbonii"
            class="mx-auto"
          >
        </a>

        <v-form
          :data="form"
          :url="url"
          method="post"
          @success="onSuccess()"
        >
          <v-input
            v-model="form.password"
            type="password"
            name="password"
            class="mb-5"
            required
            icon="lock"
            placeholder="Password"
            input-class="w-full"
          />

          <v-input
            v-model="form.password_confirmation"
            type="password"
            name="password_confirmation"
            class="mb-5"
            required
            icon="lock"
            placeholder="Password confirmation"
            input-class="w-full"
          />

          <button
            type="submit"
            class="btn btn-primary w-full mt-5"
          >
            Reset
          </button>
        </v-form>
      </div>
    </div>
  </v-master>
</template>
<script>
export default {
  data() {
    return {
      form: {
        email: this.$route.query.email,
        password : "",
        password_confirmation: "",
        token: this.$route.params.token
      }
    };
  },
  computed: {
    url() {
      return "/reset-password?token"+this.$route.params.token;
    }
  },
  methods: {
    onSuccess() {
      window.location.href = "/";
    }
  }
};
</script>
